import basicController from "servicestack/basic.controller.properties";
import templateUrl from "emun.promotion/promotion-edit.htm";
import Product from "emun.shopping/product.model";
import AutoQuery from "servicestack/auto-query/auto-query";
import resolve from "ioc/resolve";
import config from "emun.promotion/promotion.config";
import modals from 'webmodals/modals'
import webContentPrompt from 'emun.promotion/promo-webcontent-prompt'
class PromotionEditController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
	}
	$onInit() {
		const $ctrl = this;
		const id = $ctrl.promoId;
		$ctrl.promotionTypes = [{ id: "General" }, { id: "Product Specific" }];
		$ctrl.config = config;
		$ctrl.generatedFromChoices = [
			{ id: "" },
			{ id: "B2B" },
			{ id: "B2C" },
			{ id: "EMUN1" }
		];
		$ctrl.environmentChoices = [ 'B2B','CRM','Road','Show'];
		$ctrl.rewardTypes = [
			{ id: "Note On Order" },
			{ id: "Note On Order and Percent Off" },
			{ id: "Special Terms" },
			{ id: "Special Term and Percent Off" },
			{ id: "Percent Off" },
			{ id: "Dollar Amount Off" },
			{ id: "Free Shipping" },
			{ id: "Free Product" },
			{ id: "Free Product Choice" },
			{ id: "Price List" },
			{ id: "Freight Cap" },
			{ id: "Freight Cap and Special Terms" },
			{ id: "Due Date" },
			{ id: "Freight Cap and Due Date" },
			{ id: "Free Shipping and Special Terms" },
			{ id: "Free Shipping and Due Date" },
			{ id: "Single Product Discount"}
		];
		$ctrl.productListModes = [
			{ id: "Yes"},
			{id: "No"}
		];
		$ctrl.productList = "";
		$ctrl.productListMode = "Yes";
		if (id == "create") {
			$ctrl.promo = { id: "", displayOnCheckout: false, status: $ctrl.config.requireApproval ? "Pending" : "Approved", tags: {} };
			$ctrl.promo.tags['LongDescription'] = [];
			$ctrl.promo.tags['Frameworks'] = [];
			$ctrl.tagCriteria = {
				$promoCode: $ctrl.promo.id
			};
		} else {
			let options = {
				url: "QueryPromotions.json",
				autoLoad: true,
				append: false,
				pageSize: 24,
				criteria: {
					strPromotionCode: id
				},
				onLoaded: args => {
					$ctrl.promo = args.first;
					$ctrl.promo.originalPromoCode = $ctrl.promoId;
					$ctrl.promo.startOn = moment.utc($ctrl.promo.startOn);
					$ctrl.promo.endOn = moment.utc($ctrl.promo.endOn);
					$ctrl.promo.shipBefore = moment.utc($ctrl.promo.shipBefore);
					$ctrl.promo.shipAfter = moment.utc($ctrl.promo.shipAfter);
					$ctrl.promo.startDateString = moment
						.utc($ctrl.promo.startOn)
						.format("MM/DD/YYYY hh:mm a");
					$ctrl.promo.endDateString = moment
						.utc($ctrl.promo.endOn)
						.format("MM/DD/YYYY hh:mm a");
					$ctrl.promo.shipBeforeDateString = moment
						.utc($ctrl.promo.shipBefore)
						.format("MM/DD/YYYY");
					$ctrl.promo.shipAfterDateString = moment
						.utc($ctrl.promo.shipAfter)
						.format("MM/DD/YYYY");

					if ($ctrl.promo.brandId) {
						$ctrl.setVendor($ctrl.promo.brandId);
					}
					if ($ctrl.promo.tags['Product List']) $ctrl.productList = $ctrl.promo.tags['Product List'][0];
					if ($ctrl.promo.tags['Product List Mode']) $ctrl.productListMode = $ctrl.promo.tags['Product List Mode'][0];
					if (!$ctrl.promo.tags['LongDescription']) $ctrl.promo.tags['LongDescription'] = [];
					if (!$ctrl.promo.tags['Frameworks']) $ctrl.promo.tags['Frameworks'] = [];
					$ctrl.realm = "Promotion";
					$ctrl.tagCriteria = {
						$promoCode: $ctrl.promo.id
					};
		
				}
			};
			$ctrl.query = new AutoQuery(options);
			$ctrl.rewardProducts = new AutoQuery({
				url: "QueryPromotionProductsReward/" + id,
				autoLoad: true,
				append: false,
				take: 24,
				scrub(response) {
					// response.data.results = Product.map(response.data.results);
					response.data.results.forEach(
						p => (p.productDetails = new Product(p.productDetails))
					);
				}
			});
			$ctrl.qualifyProducts = new AutoQuery({
				url: "QueryPromotionProductsQualify/" + id,
				autoLoad: true,
				append: false,
				scrub(response) {
					response.data.results = Product.map(response.data.results);
				}
			});
				//$ctrl.products = new AutoQuery({ url: 'QueryProducts.json', autoLoad: true, append: true });
		}
		$ctrl.products = new AutoQuery({
			url: "QueryProducts.json",
			orderBy: "-CreatedOn",
			autoLoad: true,
			append: false,
			take: 24,
			criteria: {
				status: "Active"
			},
			sortOptions: {
				Id: "Id: Low to High",
				"-Id": "Id: High to Low",
				"ShortDescription,Id": "Description: A to Z",
				"-ShortDescription,Id": "Description: Z to A",
				"Cost,Id": "Cost: Low to High",
				"-Cost,Id": "Cost: High to Low",
				"RetailPrice,Id": "Price: Low to High",
				"-RetailPrice,Id": "Price: High to Low",
				"CreatedOn,Id": "Created",
				"-CreatedOn,Id": "Created",
				"Status,Id": "Status: A to Z",
				"-Status,Id": "Status: Z to A"
			},
			scrub(response) {
				response.data.results = Product.map(response.data.results);
			}
		});
		$ctrl.bus = $ctrl.products.bus;
		$ctrl.vendors = new AutoQuery({
			url: "QueryVendors.json",
			orderBy: "label",
			autoLoad: true,
			take: 1000
		});
		$ctrl.categories = new AutoQuery({
			url: "QueryProductCategories.json",
			autoLoad: true,
			take: 1000
		});
		$ctrl.subcategories = new AutoQuery({
			url: "QueryProductSubCategories.json",
			autoLoad: true,
			take: 1000
		});
		$ctrl.productlines = new AutoQuery({
			url: "QueryProductLines.json",
			autoLoad: true,
			take: 1000
		});
		$ctrl.ordersources = new AutoQuery({
			url: "QueryOrderSources.json",
			autoLoad: true,
			take: 1000
		});
		$ctrl.bus
			.send("QueryPriceLists.json?GroupBy=PriceListId")
			.then(function (res) {
				$ctrl.pricelists = res.data.results;
			});
		$ctrl.bus
			.send("QueryProductLists.json?ListTags=Promo&OrderBy=Label")
			.then(function (res) {
				$ctrl.productLists = [{
					id: "NONE",label:"-NONE-"
				}];
				res.data.results.map(r => $ctrl.productLists.push(r));
			});
		$ctrl.bus.send("QueryPaymentTerms.json").then(function (res) {
			$ctrl.terms = res.data.results;
		});
	}

	openWebContent() {
		const $ctrl = this;
		if (!$ctrl.promo.webContent) $ctrl.promo.webContent = {
			id: $ctrl.promo.id
		};
		webContentPrompt({...$ctrl.promo.webContent}).then(function() {
			$ctrl.query.load();
		});
	}

	updatePromotion() {
		const $ctrl = this;
		if ($ctrl.productList) {
			$ctrl.promo.tags['Product List'] = $ctrl.productList;
			$ctrl.promo.tags['Product List Mode'] = $ctrl.productListMode;
		}
		const action = `${
			$ctrl.promoId == "create" ? "Cre" : "Upd"
			}atePromotion.json`;

		return $ctrl.bus.send(action, $ctrl.promo).then(() => {
			resolve("$state").go("promotions");
		});
	}

	validateSyntax() {
		const $ctrl = this;
		const action = `${
			$ctrl.promoId == "create" ? "Cre" : "Upd"
			}atePromotion.json`;

		return $ctrl.bus.send(action, $ctrl.promo).then(() => {
			return $ctrl.bus
				.send("ValidatePromoCriteria", {
					promoCode: $ctrl.promo.id
				})
				.then(function (response) {
					if (response.data.validSql) {
						modals.alert("Valid syntax", "Syntax check successful");
					} else {
						modals.alert(response.data.message, "Syntax check failed");
					}
				});
		});
	}

	setVendor(id) {
		let $ctrl = this;
		$ctrl.productlines.criteria = {
			vendorId: id
		};
		$ctrl.productlines.load(true);

		$ctrl.categories.criteria = {
			vendorId: id
		};
		$ctrl.categories.load(true);

		$ctrl.subcategories.criteria = {
			vendorId: id
		};
		$ctrl.subcategories.load(true);
	}

	checkProductQualify(id) {
		let $ctrl = this;
		return $ctrl.qualifyProducts != undefined
			? $ctrl.qualifyProducts.results
				.map(function (e) {
					return e.id;
				})
				.indexOf(id)
			: false;
	}

	checkProductReward(id) {
		let $ctrl = this;
		return $ctrl.rewardProducts
			? $ctrl.rewardProducts.results
				.map(function (e) {
					return e.productId;
				})
				.indexOf(id)
			: false;
	}

	setSelectAll() {
		let $ctrl = this;
		$ctrl.selectAll = !$ctrl.selectAll;
		$ctrl.products.results.forEach(function (p, index) {
			$ctrl.products.results[index].isSelected = $ctrl.selectAll;
		});
	}

	addProduct(id, type, salesprice, qty) {
		let $ctrl = this;
		var productIds = [];
		productIds.push(id);
		if ($ctrl.promoId == "create") {
			$ctrl.updatePromotion().then(function () {
				return $ctrl.bus
					.send("AddPromotionProducts", {
						id: $ctrl.promo.id,
						type: type,
						productIds: productIds,
						salesprice: salesprice,
						qty: qty
					})
					.then(function (response) {
						$ctrl.qualifyProducts.load(true).then(function (response) {
							$ctrl.products.load(true);
						});
						$ctrl.rewardProducts.load(true).then(function (response) {
							$ctrl.products.load(true);
						});
					});
			});
		} else {
			return $ctrl.bus
				.send("AddPromotionProducts", {
					id: $ctrl.promo.id,
					type: type,
					productIds: productIds,
					salesprice: salesprice,
					qty: qty
				})
				.then(function (response) {
					$ctrl.qualifyProducts.load(true).then(function (response) {
						$ctrl.products.load(true);
					});
					$ctrl.rewardProducts.load(true).then(function (response) {
						$ctrl.products.load(true);
					});
				});
		}
	}

	addAllProducts(type) {
		let $ctrl = this;
		if ($ctrl.promoId == "create") {
			$ctrl.updatePromotion().then(function () {
				return $ctrl.bus
					.send("AddPromotionProducts", {
						id: $ctrl.promo.id,
						type: type,
						search: $ctrl.products.criteria.search
					})
					.then(function (response) {
						$ctrl.qualifyProducts.load(true).then(function (response) {
							$ctrl.products.load(true);
						});
						$ctrl.rewardProducts.load(true).then(function (response) {
							$ctrl.products.load(true);
						});
					});
			});
		} else {
			return $ctrl.bus
				.send("AddPromotionProducts", {
					id: $ctrl.promo.id,
					type: type,
					search: $ctrl.products.criteria.search
				})
				.then(function (response) {
					$ctrl.qualifyProducts.load(true).then(function (response) {
						$ctrl.products.load(true);
					});
					$ctrl.rewardProducts.load(true).then(function (response) {
						$ctrl.products.load(true);
					});
				});
		}
	}

	removeAllProducts(type) {
		let $ctrl = this;
		return $ctrl.bus
			.send("RemovePromotionProducts", {
				id: $ctrl.promo.id,
				type: type,
				search: $ctrl.products.criteria.search
			})
			.then(function (response) {
				$ctrl.qualifyProducts.load(true).then(function (response) {
					$ctrl.products.load(true);
				});
				$ctrl.rewardProducts.load(true).then(function (response) {
					$ctrl.products.load(true);
				});
			});
	}

	removeProduct(id, type) {
		let $ctrl = this;
		var productIds = [];
		productIds.push(id);
		return $ctrl.bus
			.send("RemovePromotionProducts", {
				id: $ctrl.promo.id,
				type: type,
				productIds: productIds
			})
			.then(function (response) {
				$ctrl.qualifyProducts.load(true).then(function (response) {
					$ctrl.products.load(true);
				});
				$ctrl.rewardProducts.load(true).then(function (response) {
					$ctrl.products.load(true);
				});
			});
	}

	requestApproval() {
		let $ctrl = this;
		return $ctrl.bus.send("RequestPromoApproval", {
			id: $ctrl.promo.id
		}).then(function (response) {
			$ctrl.query.load();
		});
	}

	approve() {
		let $ctrl = this;
		return $ctrl.bus.send("ApprovePromotion", {
			id: $ctrl.promo.id
		}).then(function (response) {
			$ctrl.query.load();
		});
	}

	updateProduct(id, price, qty, type) {
		let $ctrl = this;
		var productIds = [];
		productIds.push(id);
		return $ctrl.bus
			.send("RemovePromotionProducts", {
				id: $ctrl.promo.id,
				type: type,
				productIds: productIds
			})
			.then(function (response) {
				$ctrl.qualifyProducts.load(true).then(function (response) {
					$ctrl.products.load(true);
				});
				$ctrl.rewardProducts.load(true).then(function (response) {
					$ctrl.products.load(true);
				});
			});
	}
}

let PromotionEdit = {
	controller: PromotionEditController,
	bindings: {
		promoId: "@"
	},
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

export default PromotionEdit;
